import React, {useEffect, useState} from "react";
import moment from "moment/moment";
import {useDispatch, useSelector} from "react-redux";
import { getMaterialSpends} from "../../../actions/material";
import CustomPagePagination from "../../layout/CustomPagePagination";
import {Link} from "react-router-dom";

const MaterialSpends = () => {
    const dispatch = useDispatch();

    const {
        material,
        material_spends
    } = useSelector(state => state.material);

    const {meta, data} = material_spends;

    const {id} = material;
    useEffect(() => {
        if (id) {
            dispatch(getMaterialSpends(id, {}));
        }
    }, [getMaterialSpends, id]);

    const [from_date, setFromDate] = useState('');
    const [to_date, setToDate] = useState('');

    const onChangeFromDate = (event) => {
        setFromDate(event.target.value);
        const url = new URL(window.location);
        url.searchParams.set('from_date', event.target.value);
        url.searchParams.set('to_date', to_date);
        window.history.pushState({}, '', url);
        const params = {};
        params.to_date = to_date;
        params.from_date = event.target.value;
        dispatch(getMaterialSpends(id, params))
    };

    const onChangeToDate = (event) => {
        setToDate(event.target.value);
        const url = new URL(window.location);
        url.searchParams.set('to_date', event.target.value);
        url.searchParams.set('from_date', from_date);
        window.history.pushState({}, '', url);
        const params = {};
        params.to_date = event.target.value;
        params.from_date = from_date;
        dispatch(getMaterialSpends(id, params))
    };
    return (
        <div className="w-100 table-responsive px-2">
            <div className="row mb-3">
                <div className="col-md-6">
                    <h4>Material sarfi</h4>
                </div>
                {/*<div className="col-md-6">*/}
                {/*    <div className="crud_actions text-end">*/}
                {/*        <button className="btn btn-primary"*/}
                {/*                onClick={() => handleShow()}>*/}
                {/*            Import*/}
                {/*            <Plus/>*/}
                {/*        </button>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>

            <div className="mb-2 align-items-center d-flex
                                                        justify-content-between">
                <div className="mb-3">
                    <label htmlFor="date1"
                           className="mb-2">dan</label>
                    <input onChange={onChangeFromDate}
                           className="form-control"
                           id="date1" type="date"/>
                </div>

                <div className="mb-3">
                    <label htmlFor="date2"
                           className="mb-2">gacha</label>
                    <input onChange={onChangeToDate}
                           className="form-control"
                           id="date2" type="date"/>
                </div>
            </div>

            <table className="table custom-table table-hover">
                <thead className="table-dark">
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Mahsulot</th>
                    <th scope="col">Miqdori</th>
                    {/*<th scope="col">Narxi</th>*/}
                    <th scope="col">Sana</th>
                    {/*<th scope="col">Tahrirlash</th>*/}
                </tr>
                </thead>
                <tbody>
                {
                    data?.map((item, index) => (
                        <tr key={index}>
                            <th scope="row">{index + 1}</th>
                            <td>
                                <Link to={`/products/${item?.product?.id}`}>
                                    {item?.product?.name}
                                </Link>
                            </td>
                            <td>
                                {Number.isFinite(parseFloat(item?.amount)) ? parseFloat(item?.amount) : 0} {item?.material?.unit?.name}
                            </td>
                            <td>
                                {moment(item?.date).format("YYYY-MM-DD")}
                            </td>
                        </tr>
                    ))
                }

                <tr key={"last_import"}>
                    <th scope="row">#</th>
                    <th>
                        Hamma
                    </th>
                    <th>
                        {data?.reduce((acc, cur) => acc + (Number.isFinite(parseFloat(cur.amount)) ? parseFloat(cur.amount) : 0), 0)}
                    </th>
                    <th>
                        Jami
                    </th>
                </tr>
                </tbody>
            </table>


            <CustomPagePagination
                numberOfPages={meta?.last_page}
                getPageItems={getMaterialSpends}
                current_page={meta?.current_page}
            />
        </div>
    )
}

export default MaterialSpends;